import * as React from 'react';

function SvgCreditcardCvc(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={1} y={6} width={28} height={18} rx={4} fill="#E7E9EB" />
      <rect x={5} y={16} width={14} height={4} rx={2} fill="#fff" />
      <rect x={18.5} y={15.5} width={7} height={5} rx={2.5} stroke="#C02947" />
      <path fill="#6A7281" d="M1 10h28v3H1z" />
    </svg>
  );
}

export default SvgCreditcardCvc;
